import _defineProperty from "/Users/felipe.ramirez/Documents/quattro/valve_inventory_crystin/valve_inventory_app_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genStyle = function genStyle(token) {
  var _$concat2;
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper-rtl"), (_$concat2 = {
    direction: 'rtl',
    table: {
      direction: 'rtl'
    }
  }, _defineProperty(_$concat2, "".concat(componentCls, "-pagination-left"), {
    justifyContent: 'flex-end'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-pagination-right"), {
    justifyContent: 'flex-start'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-row-expand-icon"), {
    float: 'right',
    '&::after': {
      transform: 'rotate(-90deg)'
    },
    '&-collapsed::before': {
      transform: 'rotate(180deg)'
    },
    '&-collapsed::after': {
      transform: 'rotate(0deg)'
    }
  }), _defineProperty(_$concat2, "".concat(componentCls, "-container"), _defineProperty({
    '&::before': {
      insetInlineStart: 'unset',
      insetInlineEnd: 0
    },
    '&::after': {
      insetInlineStart: 0,
      insetInlineEnd: 'unset'
    }
  }, "".concat(componentCls, "-row-indent"), {
    float: 'right'
  })), _$concat2));
};
export default genStyle;